/*
 * Octaviano: "Passend dazu" im Warenkorb-Drawer + "Details anzeigen"-Drawer (Schnellansicht).
 * Die Schnellansicht wird per Section Rendering geladen (sections/oct-quick-view.liquid).
 * Ein iframe der echten Produktseite ist nicht möglich: Shopify sendet "frame-ancestors 'none'".
 */
(() => {
  if (window.__octUpsellLoaded) return;
  window.__octUpsellLoaded = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Texte in der Sprache des Shops (window.OctT aus layout/theme.liquid), deutsch als Rückfall
  const T = Object.assign({
    close: 'Schließen',
    ddTitle: 'Details',
    ddError: 'Die Details konnten nicht geladen werden.',
    ddLink: 'Zur Produktseite',
    infoPflege: 'Informationen zum Lederpflege-Set',
    infoSpanner: 'Informationen zum Schuhspanner'
  }, window.OctT || {});
  const refreshCart = () => {
    // Auf der Warenkorb-Seite (/cart) die Seite neu laden, damit Liste und "Passend dazu" aktuell sind.
    const pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;
    if (pageType === 'cart' || /^\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };
  const getCartDrawer = () => document.querySelector('cart-drawer');

  const addToCart = async (variantId) => {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
  };

  /* Hinweis/Fehler unter einer Größenauswahl ein- und ausblenden */
  const showMessage = (scope, type) => {
    const hint = scope.querySelector('[data-hint]');
    if (!hint) return;
    hint.textContent = type === 'error' ? hint.dataset.error : hint.dataset.hint;
    hint.hidden = false;
    if (type === 'hint') {
      scope.classList.add('is-invalid');
      const select = scope.querySelector('select');
      if (select) {
        select.setAttribute('aria-invalid', 'true');
        select.focus();
      }
    }
  };

  const clearMessage = (scope) => {
    scope.classList.remove('is-invalid');
    const select = scope.querySelector('select');
    if (select) select.removeAttribute('aria-invalid');
    const hint = scope.querySelector('[data-hint]');
    if (hint) {
      hint.hidden = true;
      hint.textContent = '';
    }
  };

  /* ---------- "Details anzeigen"-Drawer ---------- */
  const DetailsDrawer = {
    el: null,
    panel: null,
    content: null,
    title: null,
    opener: null,
    pausedTrap: null,
    previousOverflow: '',
    abortController: null,
    active: false,

    build() {
      if (this.el) return;
      const el = document.createElement('div');
      el.className = 'oct-dd';
      el.hidden = true;
      el.innerHTML = `
        <div class="oct-dd__overlay" data-oct-close></div>
        <div class="oct-dd__panel" role="dialog" aria-modal="true" aria-labelledby="oct-dd-title" tabindex="-1">
          <div class="oct-dd__header">
            <p class="oct-dd__title" id="oct-dd-title">${T.ddTitle}</p>
            <button type="button" class="oct-dd__close" data-oct-close aria-label="${T.close}">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.5"/></svg>
            </button>
          </div>
          <div class="oct-dd__body">
            <div class="oct-dd__loader" role="status">${T.loading || 'Loading …'}</div>
            <div class="oct-dd__content"></div>
          </div>
        </div>`;
      document.body.appendChild(el);

      this.el = el;
      this.panel = el.querySelector('.oct-dd__panel');
      this.content = el.querySelector('.oct-dd__content');
      this.title = el.querySelector('.oct-dd__title');

      el.addEventListener('click', (event) => {
        if (event.target.closest('[data-oct-close]')) {
          this.close();
          return;
        }
        const addButton = event.target.closest('.oct-qv__add');
        if (addButton) this.onAdd(addButton);
        // Vorschaubild unter dem Bild: Galerie dorthin schalten
        const thumb = event.target.closest('.oct-qv__thumb');
        const gallery = thumb && this.content.querySelector('.oct-qv__gallery');
        if (gallery) {
          const index = [...this.content.querySelectorAll('.oct-qv__thumb')].indexOf(thumb);
          gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'smooth' });
          this.markThumb(index);
        }
      });

      // Beim Wischen das aktive Vorschaubild mitführen
      el.addEventListener('scroll', (event) => {
        if (!event.target.classList || !event.target.classList.contains('oct-qv__gallery')) return;
        clearTimeout(this.thumbTimer);
        this.thumbTimer = setTimeout(() => {
          const g = event.target;
          this.markThumb(Math.round(g.scrollLeft / Math.max(g.clientWidth, 1)));
        }, 60);
      }, true);

      el.addEventListener('change', (event) => {
        if (event.target.matches('select')) clearMessage(this.content.querySelector('.oct-qv__form') || this.content);
      });

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        } else if (event.key === 'Tab') {
          this.trapTab(event);
        }
      }, true);
      // Kein zusätzlicher focusin-Wächter: er würde mit der Fokus-Falle von Prestige um den Fokus kämpfen
      // (Endlosschleife). Die Tab-Taste wird oben in trapTab() im Drawer gehalten.
    },

    markThumb(index) {
      this.content.querySelectorAll('.oct-qv__thumb').forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else thumb.removeAttribute('aria-current');
      });
    },

    // Schaltet sofort beim Öffnen/Schließen um (nicht erst nach der Animation).
    isOpen() {
      return this.active;
    },

    trapTab(event) {
      const focusable = [...this.panel.querySelectorAll('button, [href], select, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')]
        .filter((node) => !node.disabled && node.offsetParent !== null);
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    async open(url, titleText, opener, variantId) {
      this.build();
      this.opener = opener || null;
      // 28.10.2026: Aus Warenkorb/Drawer geöffnet → Hinweistext zum Button statt zum Häkchen
      this.el.classList.toggle('oct-pi--cart', !!(opener && opener.closest && opener.closest('cart-drawer, .oct-upsell, .cart-page, .cart-drawer')));
      this.title.textContent = titleText || T.ddTitle;
      this.content.innerHTML = '';
      this.el.classList.remove('is-loaded');

      // Prestige-Warenkorb-Drawer hat eine eigene Fokus-Falle: pausieren, solange dieser Drawer offen ist.
      const cartDrawer = getCartDrawer();
      try {
        if (cartDrawer && cartDrawer.hasAttribute('open') && cartDrawer.focusTrap) {
          cartDrawer.focusTrap.pause();
          this.pausedTrap = cartDrawer.focusTrap;
        }
      } catch (error) {
        this.pausedTrap = null;
      }

      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';

      this.active = true;
      this.el.hidden = false;
      requestAnimationFrame(() => {
        this.el.classList.add('is-open');
        this.el.querySelector('.oct-dd__close').focus();
      });

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      const sectionUrl = new URL(url, window.location.origin);
      sectionUrl.searchParams.set('section_id', 'oct-quick-view');
      if (variantId) sectionUrl.searchParams.set('variant', variantId);

      try {
        const response = await fetch(sectionUrl.pathname + sectionUrl.search, { signal: this.abortController.signal });
        if (!response.ok) throw new Error('load failed');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('[data-oct-qv]');
        if (!section) throw new Error('no content');
        this.content.replaceChildren(document.importNode(section, true));
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.content.innerHTML = `<p class="oct-dd__error">${T.ddError} <a href="${url}">${T.ddLink}</a></p>`;
      }
      this.el.classList.add('is-loaded');
    },

    async onAdd(addButton) {
      if (addButton.disabled) return;
      const form = this.content.querySelector('.oct-qv__form');
      const input = this.content.querySelector('.oct-qv__variant');
      const variantId = input ? input.value : '';
      if (!variantId) {
        showMessage(form, 'hint');
        return;
      }

      clearMessage(form);
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      try {
        await addToCart(variantId);
        refreshCart();
        this.close({ skipFocus: true });
        const cartDrawer = getCartDrawer();
        if (cartDrawer && typeof cartDrawer.show === 'function' && !cartDrawer.hasAttribute('open')) cartDrawer.show();
      } catch (error) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
        showMessage(form, 'error');
      }
    },

    close(options = {}) {
      if (!this.isOpen()) return;
      this.active = false;
      if (this.abortController) this.abortController.abort();
      this.el.classList.remove('is-open');
      document.documentElement.style.overflow = this.previousOverflow;

      const finish = () => {
        if (this.active) return; // wurde in der Zwischenzeit wieder geöffnet
        this.el.hidden = true;
        this.content.innerHTML = '';
        this.el.classList.remove('is-loaded');
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else setTimeout(finish, 280);

      if (this.pausedTrap) {
        try { this.pausedTrap.unpause(); } catch (error) { /* ignore */ }
        this.pausedTrap = null;
      }

      if (!options.skipFocus) {
        // Kurz warten: die Fokus-Falle des Warenkorbs setzt beim Fortsetzen selbst den Fokus.
        const opener = this.opener;
        setTimeout(() => {
          if (opener && document.contains(opener)) opener.focus();
          else {
            const cartDrawer = getCartDrawer();
            if (cartDrawer) cartDrawer.focus();
          }
        }, 60);
      }
      this.opener = null;
    },
  };

  window.OctDetailsDrawer = DetailsDrawer;

  /* ---------- Empfehlungs-Eintrag im Warenkorb ---------- */
  class OctUpsellItem extends HTMLElement {
    connectedCallback() {
      if (this.__octBound) return;
      this.__octBound = true;
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => {
        if (event.target.matches('select')) clearMessage(this);
      });
    }

    async onClick(event) {
      const input = this.querySelector('.oct-upsell__variant');
      const variantId = input ? input.value : '';

      const detailsTrigger = event.target.closest('[data-oct-details]');
      if (detailsTrigger) {
        event.preventDefault();
        // Pflegeset und Schuhspanner: dasselbe Pop-up wie auf der Produktseite (Bilder zum Wischen, Vorschaubilder, Häkchen).
        // Wunsch Luca 21.10.2026. Andere Produkte weiter über die Schnellansicht.
        // 28.10.2026: Erkennung über den Produkt-Handle (gleich in jeder Sprache), Titel nur als Rückfall
        const info = infoTargets.find((t) => (detailsTrigger.dataset.octHandle ? detailsTrigger.dataset.octHandle === t.handle : t.match.test(detailsTrigger.dataset.octTitle || '')) && document.getElementById(t.dialog.templateId));
        if (info) {
          info.dialog.open(detailsTrigger);
          return;
        }
        DetailsDrawer.open(detailsTrigger.dataset.octDetails, detailsTrigger.dataset.octTitle, detailsTrigger, variantId);
        return;
      }

      const addButton = event.target.closest('.oct-upsell__add');
      if (!addButton || addButton.disabled) return;
      event.preventDefault();

      if (!variantId) {
        showMessage(this, 'hint');
        return;
      }

      clearMessage(this);
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      try {
        await addToCart(variantId);
        refreshCart();
      } catch (error) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
        showMessage(this, 'error');
      }
    }
  }

  if (!window.customElements.get('oct-upsell-item')) {
    window.customElements.define('oct-upsell-item', OctUpsellItem);
  }

  /* ---------- Position: "Passend dazu" direkt unter die Artikel ----------
   * Judge.me hängt sein Bewertungs-Karussell (.jdgm-review-widget, ca. 600 px hoch) an die Artikel an.
   * Ohne diese Korrektur rutscht "Passend dazu" darunter und ist ohne Scrollen nicht sichtbar. */
  const placeUpsell = () => {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;
    const upsell = cartDrawer.querySelector('.oct-upsell');
    const reviews = cartDrawer.querySelector('.jdgm-review-widget');
    if (upsell && reviews && (reviews.compareDocumentPosition(upsell) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      reviews.before(upsell);
    }
  };

  const observeCartDrawer = () => {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;
    new MutationObserver(placeUpsell).observe(cartDrawer, { childList: true, subtree: true });
    placeUpsell();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeCartDrawer);
  else observeCartDrawer();

  /* ---------- Zahlungs-Icons unter dem GemPages-Button "In den Warenkorb" (Produktseiten) ----------
   * Haupt-Button = der GemPages-Button, dessen Formular zum Produkt dieser Seite gehört
   * (nicht die Buttons bei "Das könnte dir auch gefallen"). Die Icons kommen aus dem
   * <template id="oct-payment-icons-product"> in layout/theme.liquid. */
  const placeProductIcons = () => {
    const template = document.getElementById('oct-payment-icons-product');
    const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    const productId = meta && meta.product && String(meta.product.id);
    if (!template || !productId || document.querySelector('.oct-payment-icons--product')) return;

    const mainButton = [...document.querySelectorAll('gp-product-button')].find((button) => {
      const form = button.closest('form');
      const idInput = form && form.querySelector('[name="product-id"]');
      return idInput && idInput.value === productId;
    });
    if (!mainButton) return;

    const icons = template.content.querySelector('.oct-payment-icons');
    if (!icons) return;
    const clone = icons.cloneNode(true);
    clone.classList.add('oct-payment-icons--product');
    mainButton.after(clone);
    alignProductIcons();
  };

  // GemPages gibt dem Button-Element unten eigenen Abstand (z. B. 20 px). Ausgleichen, damit die Icons
  // immer genau 14 px unter dem sichtbaren Button stehen, auf Handy und Desktop.
  const alignProductIcons = () => {
    const row = document.querySelector('.oct-payment-icons--product');
    const wrapper = row && row.previousElementSibling;
    const button = wrapper && wrapper.querySelector('button');
    if (!button) return;
    row.style.marginTop = '14px';
    row.style.marginBottom = '';
    const extra = wrapper.getBoundingClientRect().bottom - button.getBoundingClientRect().bottom;
    if (extra > 0) {
      row.style.marginTop = `${14 - extra}px`;
      row.style.marginBottom = `${extra}px`; // Abstand zum nächsten Element wie vorher
    }
  };
  window.addEventListener('resize', () => requestAnimationFrame(alignProductIcons));

  const initProductIcons = () => {
    if (!document.getElementById('oct-payment-icons-product')) return;
    placeProductIcons();
    // GemPages baut Elemente teils nachträglich auf: kurz beobachten und bei Bedarf erneut einsetzen.
    const observer = new MutationObserver(placeProductIcons);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductIcons);
  else initProductIcons();

  /* ---------- Einheitliche Häkchen-Liste auf den Schuh-Produktseiten ----------
   * Inhalt: <template id="oct-checks-template"> aus snippets/oct-produkt-haekchen.liquid.
   * Platz: dort, wo GemPages seine eigene Liste hat (.g17MELVfKc, direkt unter den Judge.me-Sternen).
   * Fehlt das GemPages-Element, kommt die Liste direkt hinter die Zeile mit den Sternen. */
  const placeChecks = () => {
    const template = document.getElementById('oct-checks-template');
    if (!template || document.querySelector('.oct-checks')) return;
    const list = template.content.querySelector('.oct-checks');
    if (!list) return;
    const old = document.querySelector('[id*="__gp_section_"] .g17MELVfKc');
    if (old) {
      old.before(list.cloneNode(true));
      return;
    }
    const badge = document.querySelector('[id*="__gp_section_"] .jdgm-preview-badge');
    const anchor = badge && (badge.closest('gp-row') || badge.closest('[gp-el-wrapper]'));
    if (anchor) anchor.after(list.cloneNode(true));
  };

  const initChecks = () => {
    if (!document.getElementById('oct-checks-template')) return;
    placeChecks();
    const observer = new MutationObserver(placeChecks);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initChecks);
  else initChecks();

  /* ---------- Info-Symbol + Pop-up neben Kaching-Zeilen (Lederpflege-Set, Schuhspanner) ----------
   * Die Checkbox kommt von Kaching: die ganze Zeile (.kaching-bundles__bar-main, role="checkbox") schaltet
   * bei jedem Klick um. Das "i" sitzt darin, stoppt aber Klick und Tastatur, damit die Checkbox unberührt bleibt.
   * Inhalt der Pop-ups: <template> aus snippets/oct-pflegeset-info.liquid bzw. snippets/oct-spanner-info.liquid. */
  const createInfoDialog = (templateId) => ({
    templateId,
    el: null,
    panel: null,
    opener: null,
    active: false,
    previousOverflow: '',

    build() {
      if (this.el) return true;
      const template = document.getElementById(this.templateId);
      if (!template) return false;
      this.el = template.content.querySelector('.oct-pi').cloneNode(true);
      document.body.appendChild(this.el);
      this.panel = this.el.querySelector('.oct-pi__panel');

      this.el.addEventListener('click', (event) => {
        if (event.target.closest('[data-oct-pi-close]')) this.close();
        // Vorschaubild: Galerie hier selbst weiterschalten, weil der Klick unten gestoppt wird.
        const thumb = event.target.closest('.oct-pi__thumb');
        if (thumb) {
          const gallery = thumb.closest('[data-oct-pi-gallery]');
          const track = gallery && gallery.querySelector('.oct-pi__track');
          if (track) {
            const index = [...gallery.querySelectorAll('.oct-pi__thumb')].indexOf(thumb);
            track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
          }
        }
        // Klicks nicht bis zum Dokument durchlassen: Prestige schließt sonst den offenen Warenkorb dahinter
        // (Klick "außerhalb" des Warenkorbs). So bleibt der Kunde nach dem Schließen im Warenkorb.
        event.stopPropagation();
      });

      document.addEventListener('keydown', (event) => {
        if (!this.active) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        } else if (event.key === 'Tab') {
          const focusable = [...this.panel.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')]
            .filter((node) => !node.disabled && node.offsetParent !== null);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }, true);
      return true;
    },

    open(opener) {
      if (!this.build()) return;
      this.opener = opener || null;
      // 28.10.2026: Aus Warenkorb/Drawer geöffnet → Hinweistext zum Button statt zum Häkchen
      this.el.classList.toggle('oct-pi--cart', !!(opener && opener.closest && opener.closest('cart-drawer, .oct-upsell, .cart-page, .cart-drawer')));
      // Aus dem Warenkorb geöffnet: dessen Fokus-Falle pausieren, sonst holt sie den Fokus zurück.
      const cartDrawer = getCartDrawer();
      try {
        if (cartDrawer && cartDrawer.hasAttribute('open') && cartDrawer.focusTrap) {
          cartDrawer.focusTrap.pause();
          this.pausedTrap = cartDrawer.focusTrap;
        }
      } catch (error) {
        this.pausedTrap = null;
      }
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.active = true;
      this.el.hidden = false;
      this.panel.scrollTop = 0;
      void this.el.offsetWidth; // Layout erzwingen, damit die Einblend-Animation startet (ohne requestAnimationFrame)
      this.el.classList.add('is-open');
      this.el.querySelector('.oct-pi__close').focus();
    },

    close() {
      if (!this.active) return;
      this.active = false;
      this.el.classList.remove('is-open');
      document.documentElement.style.overflow = this.previousOverflow;
      if (this.pausedTrap) {
        try { this.pausedTrap.unpause(); } catch (error) { /* ignore */ }
        this.pausedTrap = null;
      }
      const finish = () => {
        if (!this.active) this.el.hidden = true;
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else setTimeout(finish, 280);
      const opener = this.opener;
      this.opener = null;
      setTimeout(() => {
        if (opener && document.contains(opener)) opener.focus();
      }, 30);
    },
  });

  // Welche Kaching-Zeile welches Pop-up bekommt (Erkennung über den Titel der Zeile).
  const infoTargets = [
    { handle: 'octaviano-lederpflege-set', match: /lederpflege|leather care|entretien du cuir|lederverzorging|cura della pelle|cuidado del cuero/i, dialog: createInfoDialog('oct-pflegeset-dialog'), label: T.infoPflege },
    { handle: 'octaviano-schuhspanner', match: /schuhspanner|shoe tree|embauchoir|schoenspanner|schoenboom|tendiscarpe|forma per scarpe|horma/i, dialog: createInfoDialog('oct-spanner-dialog'), label: T.infoSpanner },
  ];

  window.OctPflegesetInfo = infoTargets[0].dialog;
  window.OctSpannerInfo = infoTargets[1].dialog;

  const createInfoButton = (target) => {
    const PflegesetInfo = target.dialog;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'oct-pi-trigger';
    button.setAttribute('aria-label', target.label);
    button.setAttribute('aria-haspopup', 'dialog');
    button.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><circle cx="9" cy="9" r="8.25" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="9" cy="5.4" r="1.05" fill="currentColor"/><path d="M9 8v5.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

    // Nichts davon darf die Kaching-Checkbox erreichen.
    const stop = (event) => event.stopPropagation();
    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach((type) => {
      button.addEventListener(type, stop);
    });
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      PflegesetInfo.open(button);
    });
    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        PflegesetInfo.open(button);
      }
    });
    button.addEventListener('keyup', stop);
    return button;
  };

  const placeInfoButtons = () => {
    document.querySelectorAll('.kaching-bundles__checkbox-upsells__upsell').forEach((row) => {
      const title = row.querySelector('.kaching-bundles__bar-title');
      if (!title) return;
      const target = infoTargets.find((t) => t.match.test(title.textContent) && document.getElementById(t.dialog.templateId));
      if (!target) return;
      const line = title.closest('.kaching-bundles__bar-first-line') || title.parentElement;
      if (line.querySelector('.oct-pi-trigger')) return;
      title.after(createInfoButton(target));
    });
  };

  const initPflegesetInfo = () => {
    if (!infoTargets.some((t) => document.getElementById(t.dialog.templateId))) return;
    placeInfoButtons();
    // Kaching rendert die Zeilen nach (z. B. bei Variantenwechsel): dauerhaft, aber nur im Kaching-Block beobachten.
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        placeInfoButtons();
      });
    });
    const watch = () => document.querySelectorAll('kaching-bundle').forEach((block) => {
      if (block.__octPiObserved) return;
      block.__octPiObserved = true;
      observer.observe(block, { childList: true, subtree: true });
    });
    watch();
    // Falls Kaching erst später geladen wird: kurz auf den Block warten.
    const bodyObserver = new MutationObserver(() => {
      watch();
      placeInfoButtons();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => bodyObserver.disconnect(), 10000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPflegesetInfo);
  else initPflegesetInfo();
})();
